import { store } from '@common/store/store';
import { sDs } from '@common/sDs/sDs';
import { library } from "@common/library/library";

const signinStore = {
    namespaced: true,
    state: {
        stationId: null,
        settings: null,
        geolocationEnabled: false,
        geolocationFailed: 0,
        browserLat: '',
        browserLng: '',
        isNotConfiguredByGeo: false,
        permanentKeyboard: false,
        controls: [],
        isConfigured: false,
        volunteer: false,
        isGuest: false,
        fields: {
            vol: [
                "VOL_FIRST_NAME",
                "VOL_LAST_NAME",
                "VOL_SIGNED_IN",
                "VOL_SIGNIN_STATION",
                "VOL_SIGNIN_OPP",
                "VOL_SIGNIN_SLOT",
                "VOL_SIGNIN_DATETIME"
            ],
            sch: [
                "SS_DESC",
                "SS_START_DATE",
                "OPP_TITLE",
                "OPPORTUNITY_ID",
                "SS_DATE",
                "SS_START",
                "SS_END_DATE",
                "SS_START_TIME",
                "SS_FINISH_TIME",
                "SS_EXPIRE_DATE",
                "SS_REPEATED",
                "SS_REPEATED_ID",
                "SS_REPEAT_SHOW_ONCE",
                "SS_REPEAT_TERM",
                "GROUPSIZE",
                "SS_NOTE"
            ]
        },
    },
    getters: {
        getStationSettings: function (state) {
            return async function () {
                if (state.stationId) {
                    let response = await sDs.post("er_getSISOptions", state.stationId);
                    if (response.status === 'success') {
                        let controls = response.data.fieldData;
                        let selectOptions = response.data.listValues;
                        for (let i in controls) {
                            if (i === 'length') continue;
                            controls[i].type = controls[i].INPUT_TYPE;
                            controls[i].name = i;
                            if (i === 'SIS_NAME') {
                                document.title = controls[i].value;
                            }
                            if (i === "SIO_LOGO_URL") {
                                controls['SIS_LOGO'] = {};
                                controls["SIS_LOGO"].type = 'image';
                                controls['SIS_LOGO'].value = controls[i].value ? controls[i].value.replace("crc=", "") : '';
                            }
                            if (selectOptions[i]) {
                                controls[i].items = [];
                                for (let j in selectOptions[i]) {
                                    if (j === 'length') continue;
                                    controls[i].items.push({ text: selectOptions[i][j], value: j });
                                }
                                if (controls[i].value === null && controls[i].items.length) {
                                    controls[i].value = controls[i].items[0].value;
                                }
                            }
                            if (
                                i === "SIS_SPECIFIC_AUTH"
                                && selectOptions[i]
                                && selectOptions[i][controls[i].value]
                            ) {
                                controls["VOL_SPECIFIC"] = {};
                                controls["VOL_SPECIFIC"].label = selectOptions[i][controls[i].value];
                                controls["VOL_SPECIFIC"].required = true;
                                controls["VOL_SPECIFIC"].type = 'string';
                                if (controls["SIS_SPECIFIC_AUTH_KEYBOARD"].value > 0 && controls["SIS_SPECIFIC_AUTH_KEYBOARD"].value === 1) {
                                    controls["VOL_SPECIFIC"].keyboardLayout = controls["SIS_SPECIFIC_AUTH_KEYBOARD"].value === 1 ? "compact" : "numeric";
                                }
                                if (controls["SIS_SPECIFIC_AUTH_KEYBOARD"].value > 0 && controls["SIS_SPECIFIC_AUTH_KEYBOARD"].value !== 1) {
                                    state.permanentKeyboard = true;
                                    // controls["VOL_SPECIFIC"].keyboardLayout = controls["SIS_SPECIFIC_AUTH_KEYBOARD"].value === 1 ? "compact" : "numeric";
                                }
                            }
                            if (i === "SIS_SIGNIN_METHOD") {
                                if (controls["VOL_SPECIFIC"] && controls["VOL_SPECIFIC"].label) {
                                    for (let itemId in controls[i].items) {
                                        if (itemId === 'length') continue;
                                        if (controls[i].items[itemId].value !== "7") continue;
                                        controls[i].items[itemId].text = controls["VOL_SPECIFIC"].label;
                                    }
                                }
                                if (controls[i].value) controls[i].default = controls[i].value.toString();
                                else controls[i].default = "1";

                                if (controls['SIS_ALLOW_GUEST_SIGNIN'].value === 1) {
                                    controls['SIS_SIGNIN_METHOD'].items.push({ text: "Guest Sign-In", value: "8" });
                                }
                            }
                        }
                        state.controls = controls;
                        let checkPassed = true;
                        /* istanbul ignore next */
                        if (
                            checkPassed
                            && typeof state.controls['SIS_LOCATION_ACCURACY'] !== 'undefined'
                            && state.controls['SIS_LOCATION_ACCURACY'].value
                        )
                        {
                            checkPassed = false;
                            library.geolocation.watchLocation = true;
                            library.geolocation.funcOnSuccess = signinStore.checkDistance;
                            library.geolocation.funcOnFail = signinStore.checkDistance;
                            library.geolocation.getLocation();
                        }
                        if (checkPassed) {
                            state.isConfigured = true;
                        }
                    }
                }
                return state.controls;
            };
        },
    },
    actions: {
        /* istanbul ignore next */
        checkDistance({ state }, payload) {
            let lat = state.controls['SIS_COORD_LATITUDE'].value;
            let lng = state.controls['SIS_COORD_LONGITUDE'].value;
            let [currentLat, currentLng, fromWatch] = Object.values(payload);
            if (currentLat && currentLng) {
                state.geolocationEnabled = true;
                state.browserLat = currentLat;
                state.browserLng = currentLng;
            }
            if (state?.controls?.['SIS_USE_OPP_COORD']?.value || state?.controls?.['SIS_USE_ORG_COORD']?.value) {
                state.geolocationFailed = 0;
                state.isConfigured = true;
                return;
            }
            if (lat !== '' && lng !== '' && lat !== '0' && lng !== '0') {
                let minGeoDistance = 100;
                if (currentLat && currentLng) {
                    if (library.geolocation.getDistanceFromLatLonInM(lat, lng, currentLat, currentLng) > minGeoDistance) {
                        if (fromWatch && state.geolocationFailed < 3) {
                            state.geolocationFailed++;
                            return;
                        }
                        state.geolocationFailed = 0;
                        state.isConfigured = false;
                        state.isNotConfiguredByGeo = true;
                    } else {
                        state.geolocationFailed = 0;
                        state.isConfigured = true;
                    }
                } else {
                    state.isConfigured = false;
                    state.isNotConfiguredByGeo = true;
                }
            } else {
                state.isConfigured = true;
            }
        },
        /* istanbul ignore next */
        checkResponse({ state }, payload) {
            let [response] = Object.values(payload);
            if (response) {
                if (response.status === 'success') {
                    return true;
                }
                if (response.error) {
                    let message = response.error.join(" ");
                    library.showToast(message);
                }
            }
            return false;
        }
    },
};

store.registerModule('signinStore', signinStore);
export { signinStore };
